import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import queryString from 'query-string';
import { useLocation } from "react-router";
import "./css/App.css";
import "./css/tooltip.css";
import "./toasttooltip/toast.css"
/*import "./css/toastsnackbar.css"*/
import "./modallg/modal.css"
import "./modalsmall/modal.css"
import "./css/pgtopbutton.css"
import "./css/tabbedcontainer.css";
import "./css/sad.css";
import "./css/login.css";
import "./menu/menu.css";
import './css/index.css';
import './css/darken.css';
import './css/mediaresponse.css';
import './css/form-floating-labels.css';

/*
import './css/responsive.css';
import './css/responsive_sections.css';
*/




import './autocomplete/jquery-ui.css';
import './autocomplete/jquery-ui.js';

//import "./toasttooltip/toast.js"

import Jobqadm from "./components/jobqadm";
import Jobqueue from "./components/jobqueue";
import Trusteddevices from "./components/trusteddevices";
import Restartaws from "./components/restartaws";
import Pmtvouchers from "./components/pmtvouchers";



import Sad from "./components/Sad";
import Msme from "./components/msme";
import Msmelogin from "./components/msmelogin";
import Inspact from "./components/inspact";
import Sadfinder from "./components/sadfinder";
import SadfinderLight from "./components/sadfinderlight";
import Brokergrades from "./components/brokergrades";
import Exitnote from "./components/exitnote";


import Login from "./components/Login";
import Logout from "./components/Logout";
import Dashboard from "./components/dashboard";

import Users from "./components/users"
import Aduser from "./components/aduser"
//import Essearch from "./components/essearch"
import Layout from "./components/Layout";
import NoPage from "./components/NoPage";

//import $ from 'jquery'; 





class App extends Component {
  
global_instance_id;


state = {
  visible: true
  
};

  
  render() {
  
  const queryStringParams = queryString.parse(window.location.search);
//console.log('queryStringParams: '+JSON.stringify(queryStringParams));

    return (
<BrowserRouter>
      <Routes>
      <Route path="/" element={<Layout />}>

        <Route index element={<Login />} />
      
      <Route path="jobqadm" element={<Jobqadm />} />
      <Route path="jobqueue" element={<Jobqueue />} />
      <Route path="trusteddevices" element={<Trusteddevices />} />
	  <Route path="restartaws" element={<Restartaws />} />
	  
      <Route path="pmtvouchers" element={<Pmtvouchers />} />
      
	  
	  
      <Route path="msme" element={<Msme />} />
      <Route path="msmelogin" element={<Msmelogin />} />
	  
      <Route path="inspact" element={<Inspact />} />
      <Route path="brokergrades" element={<Brokergrades />} />
      <Route path="sadfinder" element={<Sadfinder />} />
      <Route path="sadfinderlight" element={<SadfinderLight />} />
      <Route path="exitnote" element={<Exitnote />} />

      <Route path="login" element={<Login />} />
	
	  
      <Route path="logout" element={<Logout />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="sad" element={<Sad />} />
      <Route path="users" element={<Users />} />
      <Route path="aduser" element={<Aduser />} />
	  
	<Route path="*" element={<NoPage />} />

      </Route>
      </Routes>
</BrowserRouter>
	


    );
  }
}

export default App;
